import { Component } from '@angular/core';
import { IconRegistryService } from './core/services';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de-LU';
import { environment } from '../environments/environment';
import { PwaService } from './core/services/pwa.service';

@Component({
  selector: 'ml-root',
  template: `
    <button
      [style.display]="'none'"
      *ngIf="Pwa.promptEvent"
      (click)="installPwa()"
    >
      Install
    </button>
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private iconRegistry: IconRegistryService,
    private translate: TranslateService,
    public Pwa: PwaService
  ) {
    this.iconRegistry.addSvgIcons();
    this.setLanguage();
  }

  private setLanguage() {
    registerLocaleData(localeDe, 'de-LU');
    this.translate.addLangs(['en', 'de-LU']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    const localStorageLanguage = localStorage.getItem(
      environment.localStorage.language
    );
    if (localStorageLanguage) {
      this.translate.use(localStorageLanguage);
      return;
    }

    if (browserLang === 'lb') {
      this.translate.use('de-LU');
    } else {
      this.translate.use(browserLang.match(/en|de-LU/) ? browserLang : 'en');
    }
  }

  installPwa(): void {
    this.Pwa.promptEvent.prompt();
  }
}
